'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoInformatcircled = function IoInformatcircled(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 19.8c0.2 9.7-7.6 17.5-17.3 17.7s-17.5-7.6-17.7-17.3 7.6-17.5 17.3-17.7 17.5 7.6 17.7 17.3z m-17.5-11c-1.4 0-2.5 1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5z m3.4 22.1v-0.9h-1.7v-13.4h-5.1v0.9h1.7v12.5h-1.7v0.9h6.8z' })
        )
    );
};

exports.default = IoInformatcircled;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/informatcircled.js
// module id = 2287
// module chunks = 0